<template>
  <section
    v-if="promotional_header_description.length"
    class="promotion-banner"
    :class="{'-open' : conditionsMenuOpen }"
  >
    <div class="teq-container">
      <div class="promotion-container">
        <div
          class="promotions-title-container"
          v-html="promotional_header_description"
        />
        <div
          class="conditions-text"
          v-html="promotional_header_conditions"
        />
      </div>
      <div
        class="conditions-title-container"
        v-if="promotional_header_conditions.length"
        @click="openConditionsMenu()"
      >
        <!-- Show only if there are conditions -->
        <div
          class="conditions-title"
        >
          conditions
        </div>
        <svg class="toggle-button">
          <use xlink:href="#icon-arrow2"></use>
        </svg>
      </div>
    </div>
  </section>
</template>

<script>

export default {

  data() {
    return {
      conditionsMenuOpen: false,
    }
  },
  computed: {
    promotional_header_conditions() {
      let promotionalHeaderConditions = window.renaultRent.settings.promotional_header_conditions;
      promotionalHeaderConditions = promotionalHeaderConditions.replace('<p>', '');
      promotionalHeaderConditions = promotionalHeaderConditions.replace('</p>', '');
      return promotionalHeaderConditions;
    },
    promotional_header_description() {
      let promotionalHeaderDescription = window.renaultRent.settings.promotional_header_description;
      promotionalHeaderDescription = promotionalHeaderDescription.replace('<p>', '');
      promotionalHeaderDescription = promotionalHeaderDescription.replace('</p>', '');
      return promotionalHeaderDescription;
    },
  },
  methods: {
    openConditionsMenu() {
      if (this.conditionsMenuOpen === true) this.$store.commit('stepping/SET_BANNER', false)
      else this.$store.commit('stepping/SET_BANNER', true)
      this.conditionsMenuOpen = !this.conditionsMenuOpen
    },
  },
}

</script>

<style scoped lang="scss">
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";
@import "../../../../../_src/sass/config/responsive";

.promotion-banner {
  background: black;
  box-sizing: border-box;
  color: white;
  //height: auto;
  //max-height: 2.9rem;
  max-height: 2.9rem;
  overflow: hidden;
  padding: 0.8rem 0;
  transform: translateY(-1rem);
  z-index: 9;

  @include teq-breakpoint($large) {
    max-height: 3.2rem;
    min-height: 3.2rem;
    transform: translateY(0);
  }

  &.-open {
    max-height: 100rem;
    min-height: auto;
    overflow: visible;

    .toggle-button {
      transform: rotate(270deg);
    }

    .conditions-text {
      height: auto;
    }
  }
}

.teq-container {
  align-content: center;
  display: flex;
  justify-content: space-between;
}

.promotion-container {
  width: calc(100% - 11.5rem);

  @include teq-breakpoint($wide) {
    width: 72%;
  }
}

.promotions-title-container,
.promotions-title-container p {
  color: white;
  font-family: $f-graphie-book !important;
  font-size: 1.2rem !important;
  line-height: 1.8rem;
  margin-bottom: 0.5rem;

  strong {
    font-family: $f-graphie-bold;
  }
}

strong {
  font-family: $f-graphie-bold;
}

.conditions-text,
.conditions-text p {
  color: white;
  font-family: $f-graphie-book !important;
  font-size: 1.2rem !important;
  height: 0;
  line-height: 1.8rem;
  overflow: hidden;

  strong {
    font-family: $f-graphie-bold;
  }

  span {
    font-family: $f-graphie-book !important;
  }

  a {
    font-family: $f-graphie-bold;
    text-decoration: underline;
  }
}

.conditions-title-container {
  cursor: pointer;
  display: flex;
  width: 9rem;
}

.conditions-title {
  color: white;
  font-family: $f-graphie-bold;
  font-size: 1.2rem;
  line-height: 1.6rem;
  margin-right: 1rem;
  text-transform: uppercase;
}

.toggle-button {
  fill: white;
  height: 1.3rem;
  transform: rotate(90deg);
  transition: 0.4s;
  width: 0.8rem;
}

</style>
